import { parseHtml } from "@/shared/utils/string";
import axios from "axios";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";
import { makeLogger } from "@/shared/consola";

const logger = makeLogger("banner.service");

const axiosInstance = axios.create({
    baseURL: "https://www.easybanner.pl",
    headers: {
        "x-api-key": "8593b801351a4f51b6bfd748180076b3", // TODO: move to Back-end!!!
        "Content-Type": "application/json;charset=utf-8",
    },
});

axiosInstance.interceptors.response.use(
    (res) => res?.data || res,
    (errorData) => {
        const { response } = errorData;
        if (response) {
            const {
                data: { error },
            } = response;
            return Promise.reject(error);
        }
        return Promise.reject("UNKNOWN_ERROR");
    }
);

export const bannerService = {
    makeCreation(contentDocument, wallImage) {
        const { body, documentElement } = contentDocument;
        const { scrollHeight } = body;
        let scale = 2;
        if (scrollHeight > 500) {
            scale = Math.round((10 * 1000) / scrollHeight) / 10;
        }

        // Assure all relative links are base href to this source:
        const html = parseHtml(documentElement.outerHTML).replace(
            `<base href="/">`,
            `<base href="${location.origin}">`
        );
        logger.trace("Sending HTML to banner", html);

        return axiosInstance
            .post("/creations", {
                html,
                styles: wallImage
                    ? ""
                    : `#view-love{display: flex; align-items:center; justify-content:center; height: 1080px; width: 1080px;} .wall{width:500px; transform: scale(${scale});transform-origin: center center;} #madeWith {transform: scale(0.6); transform-origin: center;} #addReview {display:none;}`,
                width: "1080",
                height: !wallImage ? "1080" : scrollHeight.toString(),
                buffer: false,
                fileType: "jpg",
                deviceScale: "2",
            })
            .catch(handleErrorByMessage());
    },
};
